/*
 * Übersetzungen des Redesigns, nach Bereich getrennt. Jede Datei gehört
 * einem Bereich der Oberfläche; so können mehrere Leute gleichzeitig
 * übersetzen, ohne sich in einer Riesendatei zu begegnen. i18n.ts führt
 * alles zusammen; bei doppelten Schlüsseln gewinnt der spätere Eintrag.
 */
import { EN_FACTORY } from './factory.js';
import { EN_SHELL } from './shell.js';
import { EN_COCKPIT } from './cockpit.js';
import { EN_REVIEW } from './review.js';
import { EN_PUBLISH } from './publish.js';
import { EN_SETUP } from './setup.js';
import { EN_RECIPES } from './recipes.js';
import { EN_WIZARD } from './wizard.js';
import { EN_KONTO } from './konto.js';
import { EN_ONBOARDING } from './onboarding.js';
import { EN_PLATFORMS } from './platforms.js';
import { EN_PROFILE } from './profile.js';
import { EN_EINFACH } from './einfach.js';

export const EN_BEREICHE: Record<string, string> = {
  ...EN_SHELL, ...EN_COCKPIT, ...EN_REVIEW, ...EN_PUBLISH,
  ...EN_SETUP, ...EN_RECIPES, ...EN_WIZARD, ...EN_KONTO, ...EN_ONBOARDING, ...EN_PLATFORMS, ...EN_PROFILE, ...EN_EINFACH, ...EN_FACTORY,
};
